export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

export const fetchAndConvertImages = async (images, limit = 5) => {
  const results = [];
  const queue = [...images];

  const loadNext = async () => {
    while (queue.length) {
      const image = queue.shift();
      try {
        const fetchResponse = await fetch(image, {
          method: 'GET',
          cache: 'no-cache',
        });
        const blob = await fetchResponse.blob();
        const base64Image = await blobToBase64(blob);
        results.push({ originalUrl: base64Image, path: image });
      } catch (error) {
        console.error('Ошибка загрузки изображения:', image, error);
      }
    }
  };

  await Promise.all(Array.from({ length: limit }, () => loadNext()));
  return results;
};
